<template>
    <v-dialog width="800" persistent v-model="mostrarModalAcompanhamentoEnvioEsfinge">
        <v-card>
            <v-card-title class="primary modal-title pb-1 pt-1" primary-title>
                <span>Acompanhamento Envio Esfinge</span>
                <v-btn flat depressed @click="propagarFecharModalAcompanhamentoEnvioEsfinge">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pb-0 pt-2 az-form-content">
                <v-flex d-flex>
                    <v-flex d-flex xs12 sm7>
                        <div class="az-text">
                            <label>Protocolo</label>
                                <p class="mb-0">{{ envioEsfinge.numero }}</p>
                        </div>
                    </v-flex>
                    <v-flex d-flex xs12 sm5>
                        <div class="az-text">
                            <label>Situação</label>
                                <p class="mb-0">{{ envioEsfinge.status | cdEnum(situacoesEnvioEsfinge) }}</p>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm3 v-if="envioEsfinge.permitirEnviar && !envioEsfinge.enviandoAnexos">
                        <az-call-to-action slot="activator" @click="propagarEnvioDispensaEsfinge" active>
                            Enviar Novamente
                        </az-call-to-action>
                    </v-flex>
                    <v-flex xs12 sm2 v-if="!envioEsfinge.permitirEnviar && !envioEsfinge.enviandoAnexos">
                        <az-call-to-action slot="activator" @click="propagarAlterarDispensaEsfinge" active>
                            Alterar Envio
                        </az-call-to-action>
                    </v-flex>
                    <v-flex xs12 sm2 v-if="envioEsfinge.permitirCancelarEnvio">
                        <az-call-to-action slot="activator" @click="propagarCancelarDispensaEsfinge" active>
                            Cancelar Envio
                        </az-call-to-action>
                    </v-flex>
                    <v-flex xs12 sm3 v-if="envioEsfinge.enviandoAnexos">
                        <v-tooltip bottom>
                            <v-btn slot="activator" :disabled="true" class="call-to-action">
                                Enviando Anexos
                            </v-btn>
                            <span>Os anexos estão sendo enviados, aguarde...</span>
                        </v-tooltip>
                    </v-flex>
                </v-flex>
            </v-card-text>

            <v-data-table
                :headers="colunas"
                :items="envioEsfinge.historico"
                :pagination.sync="pagination"
                no-data-text="Erro ao buscar Acompanhamento do Envio Esfinge"
                class="az-table-list tabela-linha pt-1"
            >
                <template #items="props">
                    <td>{{ props.item.tipoOperacao | cdEnum(tiposOperacaoEsfinge) }}</td>
                    <td>
                        {{ props.item.dataProcessamento | az-date(humanizarFormatoData(props.item.dataProcessamento)) }}<br>
                        <span v-if="props.item.dataProcessamento">
                            {{ props.item.dataProcessamento | az-date(humanizarFormatoHora(props.item.dataProcessamento)) }}
                        </span>
                    </td>
                    <td>{{ props.item.status | cdEnum(situacoesEnvioEsfinge) }}</td>
                    <td>
                        <expansao-texto :tamanho="100" :texto="props.item.mensagem"/>
                    </td>
                </template>
            </v-data-table>

            <v-card-actions class="pa-3">
                <v-btn color="#777" flat @click="propagarFecharModalAcompanhamentoEnvioEsfinge">
                    Fechar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn id="botaorecarregar" class="botao-primario" flat @click="propagarBuscarDispensaEsfinge">
                    Recarregar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { situacoesEnvioEsfinge, tiposOperacaoEsfinge } from '@/core/constants'

export default {
    name: 'ModalAcompanhamentoEnvioEsfinge',
    props: {
        mostrarModalAcompanhamentoEnvioEsfinge: {
            type: Boolean
        },
        envioEsfinge: {
            type: Object
        }
    },
    data() {
        return {
            colunas: [
                { text: 'Tipo Operação', value: 'tipoOperacao', sortable: false, align: 'left', class: 'primary--text' },
                { text: 'Data Processamento', value: 'dataProcessamento', sortable: true, align: 'left', class: 'primary--text'},
                { text: 'Status', value: 'status', sortable: true, align: 'left', class: 'primary--text'},
                { text: 'Mensagem', value: 'mensagem', sortable: false, align: 'left', class: 'primary--text'},
            ],
            pagination: {
                sortBy: 'dataProcessamento',
                descending: true,
            },
            situacoesEnvioEsfinge,
            tiposOperacaoEsfinge
        }
    },
    methods: {
        propagarEnvioDispensaEsfinge() {
            this.$emit('processarEnvioModalAcompanhamentoEsfinge')
        },
        propagarAlterarDispensaEsfinge() {
            this.$emit('processarAlterarDispensaEsfinge')
        },
        propagarBuscarDispensaEsfinge() {
            this.$emit('processarBuscarDispensaEsfinge')
        },
        propagarCancelarDispensaEsfinge() {
            this.$emit('processarCancelarDispensaEsfinge')
        },
        propagarFecharModalAcompanhamentoEnvioEsfinge(){
            this.$emit('processarFecharModalAcompanhamentoEnvioEsfinge')
        },
    }
}
</script>

<style scoped lang="stylus">
.modal-title
    justify-content space-between

    .v-btn
        padding 0
        margin 0
        color #fff
        box-sizing border-box
        min-width 25px

.botao-primario
    padding 0 25px
    border 1px solid var(--v-primary-base) !important
    background-color var(--v-primary-base) !important
    color #fff !important
    box-sizing border-box
    margin-left 15px !important

.tabela-linha
    padding 10px 16px 0px
</style>